import { translate, translateRich, useLocale } from "../../localization";
import { isNewAnalyticsEnabled } from "../../services/AnalyticsReadAPI";

export default function AnalyticsModeNotice({ error }) {
  useLocale();
  if (!isNewAnalyticsEnabled || !error) return null;
  return (
    <p role="alert">{translateRich("Analytics could not be loaded. {value0}", {
  value0: error.response?.data?.error?.message || error.message || translate("Please try again.")
})}</p>
  );
}
